import React from "react";
import { AppRoute } from "../types/routes";
import Home from "../components/home/Home";
import AddBrand from "../components/home/add-brand/AddBrand";
import BrandDetails from "../components/brandDetails/BrandDetails";
import BrandFeatures from "../components/features/BrandFeatures";
import SeoPreview from "../components/seo/SeoPreview";
import Login from "../components/auth/Login";
import Signup from "../components/auth/Signup";
import AuthCallback from "../components/auth/AuthCallback";

export interface RouteConfig {
  path: AppRoute;
  component: React.ComponentType<any>;
  protected: boolean;
  props?: any;
}

export const routes: RouteConfig[] = [
  {
    path: AppRoute.LOGIN,
    component: Login,
    protected: false,
  },
  {
    path: AppRoute.SIGNUP,
    component: Signup,
    protected: false,
  },
  {
    path: AppRoute.HOME,
    component: Home,
    protected: true,
  },
  {
    path: AppRoute.ADD_BRAND,
    component: AddBrand,
    protected: true,
  },
  {
    path: AppRoute.BRAND_DETAILS,
    component: BrandDetails,
    protected: true,
  },
  {
    path: AppRoute.BRAND_FEATURES,
    component: BrandFeatures,
    protected: true,
  },
  {
    path: AppRoute.SEO_PREVIEW,
    component: SeoPreview,
    protected: true,
  },
  {
    path: AppRoute.AUTH_CALLBACK,
    component: AuthCallback,
    protected: false,
  },
];
